import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

export const sendMessage = async (data) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .post(`${BASE_URL}send-message`, data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const sendClientToAdminMessageService = async (data) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .post(`${BASE_URL}client-to-admin-message`, data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const sendGuestMessage = async (data) => {
  const result = await axios
    .post(`${BASE_URL}store-guest-message`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const getGuestConversation = async (sender) => {
  const result = await axios
    .get(`${BASE_URL}get-guest-conversation?sender=${sender}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const getClientAndAdminConversation = async (sender) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .get(`${BASE_URL}get-client-and-admin-conversation?peer_id=${sender}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const sendAdminToUserMessageService = async ({ recipientId, message, projectId }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return axios
    .post(
      `${BASE_URL}admin-to-user-message`,
      {
        recipient_id: recipientId,
        message,
        project_id: projectId,
      },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getConversation = async (recipient, sender, page, markRead = true) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .get(
      `${BASE_URL}get-conversation?recipient=${recipient}&&sender=${sender}&&page=${page}&&markRead=${markRead ? "true" : "false"}`,
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const getConversationThreadsService = async (userId, page = 1, limit = 200) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .get(
      `${BASE_URL}get-conversation-threads?userId=${userId}&&page=${page}&&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error.response);
  return result;
};

export const getConversationByProposal = async (
  recipient,
  sender,
  proposalId,
  page,
  markRead = true,
) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .get(
      `${BASE_URL}get-conversation?recipient=${recipient}&&sender=${sender}&&proposalId=${proposalId}&&page=${page}&&markRead=${markRead ? "true" : "false"}`,
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error.response);
  return result;
};

export const getConversationListService = async (recipient, page) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const result = await axios
    .get(
      `${BASE_URL}get-conversation-list?recipient=${recipient}&&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return result;
};

export const unsendMessage = async (id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const users = await axios
    .post(
      `${BASE_URL}unsend-message`,
      { id: id },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return users;
};
